<h2 class="p-6 pb-4">Опрацювати чернетки</h2>

<div class="max-h-[70vh] min-w-[600px] overflow-y-auto px-6 py-0">
  @if (existingPrescriptionItems().length > 0 || newPrescriptionItems().length > 0) {
    <div class="mb-2">
      <p class="text-neutral-500">Перегляньте чернетки призначень перед опрацюванням:</p>
    </div>
    @if (existingPrescriptionItems().length > 0) {
      <div class="my-2 px-2 text-sm font-semibold text-primary-600">Відредаговані призначення</div>
      @for (prescription of existingPrescriptionItems(); track prescription.id) {
        <div class="mb-2 flex">
          <prescriptions-item
            [memberId]="memberProfile().id"
            [prescription]="prescription"
          ></prescriptions-item>
        </div>
      }
    }
    @if (newPrescriptionItems().length > 0) {
      <div class="my-2 px-2 text-sm font-semibold text-primary-600">Нові призначення</div>
      @for (prescription of newPrescriptionItems(); track prescription.id) {
        <div class="mb-2 flex">
          <prescriptions-item
            [memberId]="memberProfile().id"
            [prescription]="prescription"
          ></prescriptions-item>
        </div>
      }
    }
  } @else {
    <div class="py-8 text-center">
      <p class="text-neutral-500">Немає чернеток призначень.</p>
    </div>
  }
</div>

<mat-dialog-actions class="mt-10 gap-4 p-6">
  <button
    class="btn btn-secondary"
    [type]="'button'"
    (click)="cancel()"
  >
    Скасувати
  </button>
  <button
    class="btn btn-primary"
    [disabled]="drafts().length === 0"
    (click)="processDrafts()"
  >
    Підтвердити
  </button>
</mat-dialog-actions>
